'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisibleInViewPort = isVisibleInViewPort;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.isCurrentUrl = isCurrentUrl;
exports.getTextFromPasteEvent = getTextFromPasteEvent;

var _cookie = require('cookie');

function isVisibleInViewPort(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 || rect.bottom >= 0;
}

/**
 * Gets the value of the cookie at `key`.
 * @param  {string} key
 * @return {string}
 */
function getCookie(key) {
  if (!document) return undefined;
  return (0, _cookie.parse)(document.cookie)[key];
}

/**
 * Sets a document cookie with the given args.
 * @see https://github.com/jshttp/cookie#serialize
 *
 * @param {string} key
 * @param {string} val
 * @param {object} opts
 */
function setCookie(key, val, opts) {
  if (!document) return;
  document.cookie = (0, _cookie.serialize)(key, '' + val, opts);
}

var urlWithoutHash = function urlWithoutHash(url) {
  var hashIndex = url.lastIndexOf('#');
  return url.substring(0, hashIndex >= 0 ? hashIndex : url.length);
};

/**
 * Checks if the URL is the same as the browser's current URL
 *
 * @param {string} url
 */
function isCurrentUrl(url) {
  return urlWithoutHash(url) === urlWithoutHash(window.location.href);
}

function getTextFromPasteEvent(e) {
  if (e.clipboardData) {
    try {
      return e.clipboardData.getData('text/plain');
    } catch (err) {
      // IE11 does not support "text/plain", but does support "text".
      return e.clipboardData.getData('text');
    }
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/utils/browser/lib/index.js
// module id = 413
// module chunks = 0 1 4